import Spinner from "@/components/Spinner";
import useCollectorScroll from "@/hooks/collector/useCollectorScroll";
import { useCallback, useEffect, useRef } from "react";
import DepositMobile from "../DepositMobile";
import AddCollection from "../addCollectio/AddCollection";
import CollectionOrderCard from "./CollectionOrderCard";

type Props = {
  refresh: () => void;
  setDepositRefreshKey: (key: any) => void;
  depositRefreshKey: number;
  setCollectRefreshKey: (key: any) => void;
  collectRefreshKey: number;
};

function CollectorViewMobile({
  refresh,
  setDepositRefreshKey,
  depositRefreshKey,
  setCollectRefreshKey,
  collectRefreshKey,
}: Props) {
  const { collections, loading, handleRefresh, loadMore } = useCollectorScroll({
    perPage: 5,
  });

  const observer = useRef<IntersectionObserver | null>(null);
  const lastCollectionElementRef = useCallback(
    (node: HTMLDivElement) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            console.log("Observer triggered, loading more data...");
            loadMore();
          }
        },
        { rootMargin: "0px 0px 200px 0px", threshold: 0.1 }
      );
      if (node) observer.current.observe(node);
    },
    [loading, loadMore]
  );

  const handleCollectionRefresh = () => {
    handleRefresh(); // Refresh collections
    refresh(); // Trigger parent refresh if needed
    setDepositRefreshKey((prevKey: any) => prevKey + 1); // Update state to trigger DepositMobile refresh
    setCollectRefreshKey((prevKey: any) => prevKey + 1); // Update state to trigger CollectMobile refresh
  };

  useEffect(() => {
    console.log("Deposit refresh triggered");
    // Trigger any refresh logic you need
  }, [depositRefreshKey]); // Runs when depositRefreshKey changes

  useEffect(() => {
    console.log("Collect refresh triggered");
    handleRefresh(); // Trigger refresh in Collector
  }, [collectRefreshKey]); // Runs when collectRefreshKey changes

  return (
    <div className="flex flex-col min-h-screen gap-4 p-4 bg-white md:hidden">
      <div className="flex gap-2">
        <div className='w-1/2'>
          <AddCollection onAddCollectionOrder={refresh} isMobile />
        </div>

        <div className="w-1/2">
          <DepositMobile
            onDeposit={() => {
              handleRefresh(); // Trigger refresh in DepositMobile
              refresh(); // Trigger refresh in Collector
              setDepositRefreshKey((prevKey: any) => prevKey + 1); // Update state to trigger DepositMobile refresh
              setCollectRefreshKey((prevKey: any) => prevKey + 1); // Update state to trigger CollectMobile refresh
            }}
            refreshKey={depositRefreshKey}
          />
        </div>
      </div>
      <h1 className="text-sm font-semibold text-primary">
        List of collections
      </h1>
      <div className="flex flex-col gap-4 ">
        {collections ? (
          collections?.map((collectionOrder: any, index: number) => (
            <div
              key={collectionOrder.id}
              ref={
                index === collections.length - 1
                  ? lastCollectionElementRef
                  : null
              }
            >
              <CollectionOrderCard
                collectionOrder={collectionOrder}
                collectionDate={collectionOrder.date}
                onCollect={handleCollectionRefresh}
              />
            </div>
          ))
        ) : (
          <h1 className="text-sm font-semibold text-black">No collections</h1>
        )}
      </div>

      {loading && <Spinner />}
    </div>
  );
}

export default CollectorViewMobile;
